import Box from "@mui/material/Box";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import React from "react";
import Typography from "@mui/material/Typography";
import { ICItemStatusEntry } from "../declarations/CItemStatusEntry";
import { PIPELINE_STEPS, getStatusForType } from "./manufacturingPipeline";

interface IManufacturingStatusPanelProps {
    isCommitting: boolean;
    onCommit: (statusTypeID: number) => void;
    onRollback: (statusTypeID: number) => void;
    statuses: ICItemStatusEntry[];
}

export default function ManufacturingStatusPanel(
    props: Readonly<IManufacturingStatusPanelProps>,
) {
    const { statuses, onCommit, onRollback, isCommitting } = props;

    return (
        <Box>
            {PIPELINE_STEPS.map((step) => {
                const status = getStatusForType(statuses, step.statusTypeID);
                const isComplete = status?.complete === true;
                const isReadOnly = step.readOnly;

                const handleClick = () => {
                    if (isReadOnly || isCommitting) return;
                    if (isComplete) {
                        onRollback(step.statusTypeID);
                    } else {
                        onCommit(step.statusTypeID);
                    }
                };

                return (
                    <Box
                        key={step.label}
                        onClick={handleClick}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            py: 0.75,
                            px: 1.5,
                            borderLeft: isReadOnly
                                ? "3px solid transparent"
                                : isComplete
                                  ? "3px solid #4caf50"
                                  : "3px solid #1976d2",
                            cursor: isReadOnly || isCommitting ? "default" : "pointer",
                            "&:hover": !isReadOnly && !isCommitting
                                ? { backgroundColor: "action.hover" }
                                : {},
                            opacity: isReadOnly && !status ? 0.5 : 1,
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{
                                fontSize: "0.85rem",
                                fontWeight: isComplete ? 600 : 400,
                            }}
                        >
                            {step.label}
                        </Typography>
                        {isComplete ? (
                            <CheckCircleIcon
                                sx={{ fontSize: 18, color: "success.main" }}
                            />
                        ) : (
                            <RadioButtonUncheckedIcon
                                sx={{ fontSize: 18, color: "action.disabled" }}
                            />
                        )}
                    </Box>
                );
            })}
        </Box>
    );
}
